'use strict';

/* global angular */

const DeleteDatasetDialogController = require('./DeleteDatasetDialogController');
const DeleteDatasetDialogDirective = require('./DeleteDatasetDialogDirective');

angular
.module('manager.processingJobs.dialog', [])
.controller('DeleteDatasetDialogController', DeleteDatasetDialogController)
.directive('deleteDatasetDialog', DeleteDatasetDialogDirective);


// WEBPACK FOOTER //
// ./src/app/manager/processing/dialogs/index.js